export default function ChevronRightIcon(props: Icon) {
  const { height, width } = props;
  return (
    <svg
      className="chevron-right"
      aria-hidden="true"
      role="img"
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : height ? height : 22}
      height={height ? height : width ? width : 22}
      viewBox="0 0 48 48"
    >
      <path
        fill="currentColor"
        d="M17.35 35.25q-.55-.65-.575-1.45-.025-.8.575-1.4l8.45-8.45-8.5-8.5q-.55-.55-.525-1.425.025-.875.575-1.425.65-.65 1.425-.625.775.025 1.375.625l9.95 9.95q.3.3.45.65.15.35.15.75t-.15.75q-.15.35-.45.65l-9.9 9.9q-.6.6-1.4.575-.8-.025-1.45-.575Z"
      />
    </svg>
  );
}
